import { createSlice } from "@reduxjs/toolkit";

const couponPromotionSlice = createSlice({
  name: "coupon_promotion",
  initialState: {
    coupon_promotion: null,
    error: false,
    errorMessage: "",
  },
  reducers: {
    getAllCouponSuccess: (state, action) => {
      state.coupons = action.payload;
    }
  },
  selectors: {
    getAllCoupons: (state) => state.coupons ?? []
  }
});

export const { getAllCouponSuccess } = couponPromotionSlice.actions;

export const { getAllCoupons } = couponPromotionSlice.selectors;

export default couponPromotionSlice.reducer;
